import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6561fe7f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "waitlist"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "waitlist__title" }, "Лист ожидания", -1))
const _hoisted_3 = {
  key: 0,
  class: "flex justify-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_ok_input = _resolveComponent("ok-input")!
  const _component_ok_button = _resolveComponent("ok-button")!
  const _component_ok_table = _resolveComponent("ok-table")!

  return (_ctx.state.list.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        (_ctx.state.is_loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_loader, { class: "primary" })
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_ok_table, {
          columns: _ctx.COLUMNS,
          rows: _ctx.state.list
        }, {
          td: _withCtx(({ column, row }) => [
            (column.key === 'title')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.getWaitListTitle(row)), 1)
                ], 64))
              : (column.key === 'actions')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_ctx.isDateInput(row))
                      ? (_openBlock(), _createBlock(_component_ok_input, {
                          key: 0,
                          placeholder: "Выберите новую дату",
                          type: "date",
                          value: row.value,
                          "onUpdate:value": ($event: any) => ((row.value) = $event),
                          "is-invalid": _ctx.state.invalid_item_id === row.id && _ctx.state.is_invalid_date,
                          class: "whitespace-nowrap"
                        }, null, 8, ["value", "onUpdate:value", "is-invalid"]))
                      : _createCommentVNode("", true)
                  ], 64))
                : (column.key === 'comment')
                  ? (_openBlock(), _createBlock(_component_ok_input, {
                      key: 2,
                      class: "item__comment",
                      placeholder: "Введите комментарий",
                      value: _ctx.state.comments[_ctx.state.list.indexOf(row)],
                      "onUpdate:value": ($event: any) => ((_ctx.state.comments[_ctx.state.list.indexOf(row)]) = $event),
                      style: { width: '200px' }
                    }, null, 8, ["value", "onUpdate:value"]))
                  : (column.key === 'accept')
                    ? (_openBlock(), _createBlock(_component_ok_button, {
                        key: 3,
                        class: "OkButton--green OkButton--xs",
                        onClick: ($event: any) => (_ctx.manageAnswer(row, 'submit')),
                        disabled: _ctx.state.is_manage_loading,
                        loading: _ctx.state.is_manage_loading
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Подтвердить ")
                        ]),
                        _: 2
                      }, 1032, ["onClick", "disabled", "loading"]))
                    : (column.key === 'decline')
                      ? (_openBlock(), _createBlock(_component_ok_button, {
                          key: 4,
                          class: "OkButton--red OkButton--xs",
                          onClick: ($event: any) => (_ctx.manageAnswer(row)),
                          disabled: _ctx.state.is_manage_loading,
                          loading: _ctx.state.is_manage_loading
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Отказ ")
                          ]),
                          _: 2
                        }, 1032, ["onClick", "disabled", "loading"]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                          _createTextVNode(_toDisplayString(row[column.key]), 1)
                        ], 64))
          ]),
          _: 1
        }, 8, ["columns", "rows"])
      ]))
    : _createCommentVNode("", true)
}